import { Link } from "react-router-dom";
import { fr } from "../content/fr";
import { CONTACT_EMAIL } from "../seo/jsonld";

export default function Footer() {
  const manageCookies = () => {
    localStorage.removeItem("viralya-consent");
    window.location.reload();
  };
  return (
    <footer className="site-footer" id="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <Link to="/" className="logo" style={{ marginBottom: "1rem" }}>
              <span className="logo__mark" aria-hidden="true"></span>
              {fr.brand.name}
            </Link>
            <p style={{ color: "var(--text-secondary)", fontSize: "0.9rem", maxWidth: "34ch" }}>{fr.footer.tagline}</p>
            <a href={`mailto:${CONTACT_EMAIL}`} className="footer-email" data-testid="footer-email" style={{ display: "inline-block", marginTop: "0.9rem", color: "var(--v-accent-text)", fontSize: "0.9rem" }}>{CONTACT_EMAIL}</a>
          </div>
          {fr.footer.columns.map((col) => (
            <div className="footer-col" key={col.t}>
              <h4>{col.t}</h4>
              {col.links.map((lnk) => (
                <Link to={lnk.to} key={lnk.l} data-testid={`footer-link-${lnk.l.slice(0, 8)}`}>{lnk.l}</Link>
              ))}
            </div>
          ))}
        </div>
        <div className="footer-bottom" style={{ display: "flex", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
          <span>{fr.footer.legalNote}</span>
          <button onClick={manageCookies} className="mono" style={{ color: "var(--v-accent-text)", fontSize: "0.78rem", minHeight: 44, display: "inline-flex", alignItems: "center", padding: "0 2px" }} data-testid="footer-manage-cookies">{fr.footer.manageCookies}</button>
        </div>
      </div>
    </footer>
  );
}
